export default __webpack_public_path__ + "static/media/abba.9a5242e3.jpg";